import * as actions from './actions'
// import * as getters from './getters'
// import * as mutations from './mutations'

export default {
  state: {
    info: {
      id: '1',
      name: 'Main'
    },
    list: []
  },
  // mutations,
  actions
  // getters
}
